import * as React from 'react';
import ChangeComplete from '../../components/misc/change-complete';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';
import { getUrlParameter } from '@enginuity-common/utils/url';


export default function ConfirmPasswordChange() {
  const fromUri = getUrlParameter('redirectUrl');

  return (<>
    <ChangeComplete>
      <div className="row spacer-32">
        <div className="col-12">
          <h3>Your password has been successfully reset</h3>
        </div>
      </div>
      <div className="row spacer-48">
        <div className="col-12">
          <Button buttonType="link" href={`/signin` + (fromUri && `?fromURI=${fromUri}`)} className="cmp-button--secondary">Sign in</Button>
        </div>
      </div>
    </ChangeComplete>
  </>
  );

}
